import { OperationContext } from "urql";

import { FlagsByTypename, getAdditionalTypenamesForOperation } from "./getAdditionalTypenamesForOperation";

export interface IGetOperationContextOpts<Operation> {
    additionalTypenameFlags?: FlagsByTypename<Operation>;
}

export function getOperationContext<Operation>({
    additionalTypenameFlags = {},
}: IGetOperationContextOpts<Operation> = {}): Partial<OperationContext> {
    const additionalTypenames = getAdditionalTypenamesForOperation<Operation>(additionalTypenameFlags);

    return { additionalTypenames };
}
